<template>
  <div class="action-float-left mx-1">
     <vx-tooltip :text="$t('delete')">
        <feather-icon
          @click="handleClick"
          :icon="icon"
          svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block"
        />
      </vx-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'TrashIcon',
    },
  },
  methods: {
    handleClick() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].confirm,
        text: this.$i18n.messages[this.$i18n.locale].delete_message_confirm,
        acceptText: this.$i18n.messages[this.$i18n.locale].accept,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.accept,
      })
    },
    accept() {
      this.$emit('delete')
    },
  },
}
</script>

<style>
</style>
